<template>
  <footer id="MainFooter">
    <div class="main_container">
      <div class="link_container">
        <ol class="menu_list">
          <li
            v-for="(item, itemIndex) in menuListData"
            :key="`menu_${itemIndex}`"
          >
            <router-link :to="item.Link">{{ item.Title }}</router-link>
          </li>
        </ol>

        <ol class="social_list">
          <li>
            <a
              :href="$store.getters.columnData('company_facebook')"
              target="_blank"
              >Facebook</a
            >
          </li>
          <li>
            <a
              :href="$store.getters.columnData('company_instagram')"
              target="_blank"
              >Instagram</a
            >
          </li>
          <!-- <li>
            <a
              :href="$store.getters.columnData('company_youtube')"
              target="_blank"
              >Youtube</a
            >
          </li> -->
          <li>
            <a :href="$store.getters.columnData('company_line')" target="_blank"
              >LINE@</a
            >
          </li>
        </ol>
      </div>
    </div>

    <div class="bottom_container">
      <div class="info_box">
        <p>© 2024 {{ $store.getters.columnData("company_name") }}</p>
        <ol class="terms_list">
          <li>
            <router-link to="/terms/site_privacy">隱私權政策</router-link>
          </li>
        </ol>
      </div>

      <p class="design_by">
        網頁設計：<a href="https://www.yongxin-design.com" target="_blank"
          >泳欣事業有限公司</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      menuListData: [
        {
          Title: "線上車庫",
          Link: "/collections",
        },
        {
          Title: "門市資訊",
          Link: "/shop_info",
        },
        {
          Title: "最新消息",
          Link: "/news",
        },
      ],
    };
  },
};
</script>
